<template>
  <default-layout>
    <div class="settings-wrapper">
      <page-header class="page-header" :class="theme">{{ $t('SETTINGS_HEADER') }}</page-header>
      <main class="body" role="main">
        <section class="nav">
          <settings-nav />
        </section>
        <section class="content" id="main">
          <transition name="settings-subnav">
            <nuxt />
          </transition>
        </section>
      </main>
    </div>
    <confirmation-modal
      name="logout-modal"
      :title="$t('MORE_LOGOUT_CONFIRM_LABEL')"
      :cancel="$t('MORE_LOGOUT_CONFIRM_CANCEL_CTA')"
      :confirm="$t('MORE_LOGOUT_CONFIRM_CONFIRM_CTA')"
      :to="logoutPath"
      @cancel="cancelLogout"
      @confirm="confirmLogout"
    />
  </default-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { SETTINGS_NAV_ROUTES } from '~/constants'
import Theme from '~/constants/theme'
import DefaultLayout from '~/layouts/default'
import UIMixin from '~/mixins/ui'
import PageHeader from '~/components/page-header'
import SettingsNav from '~/components/settings-nav/SettingsNav'

const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

const { Dark, Light } = Theme

export default {
  authenticated: true,

  middleware: [
    'fetchUser',
    'isAuthorized',
    'canAccessMemberApp',
    'hasBeenInducted',
    'initializer'
  ],

  mixins: [UIMixin],

  components: {
    DefaultLayout,
    PageHeader,
    SettingsNav
  },
  data () {
    return {
      SETTINGS_NAV_ROUTES
    }
  },

  computed: {
    ...mapEnvGetters(['isDarkTheme']),

    logoutPath () {
      return this.localePath({ name: 'logout' })
    },

    theme () {
      return this.isDarkTheme ? Dark : Light
    }
  },

  methods: {
    logout () {
      this.$ui.modal.open('logout-modal')
    },
    cancelLogout () {
      this.$ui.modal.close('logout-modal')
    },
    confirmLogout () {
      this.$ui.modal.close('logout-modal')
      this.$router.push(this.localePath({ name: 'logout' }))
    }
  }
}
</script>

<style lang="scss" scoped>
.settings-wrapper {
  position: relative;
  padding-bottom: $footer-tablet-padding;
  min-height: 100vh;

  .dark {
    background: $color-black
  }
}

.close {
  @include font('050');

  position: absolute;
  left: $space-040;
  cursor: pointer;
}

main.body {
  display: flex;
  flex-direction: column;
  max-width: $page-width;
  width: 100%;
  margin: 0 auto;
  padding: $space-060 $space-040;

  @include tablet {
    flex-direction: row;
  }

  section.content {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include tablet {
      flex-grow: 1;
      justify-content: flex-start;
      margin-left: $space-080;
      width: min-content;
    }
  }

  section.nav {
    display: none;
    min-width: 30%;
    height: fit-content;
    padding: $space-070 $space-060;
    border-radius: 5px;
    border: 1px solid $color-gray_5;

    @include tablet {
      display: table;
    }
  }
}
</style>
